// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2OnsU","content":"Consent_content__27NKl","footer":"Consent_footer__3sc54"};